<template>
  <section>
    <div class="row">
      <div class="col-lg-4 d-none .d-md-none d-lg-block align-self-center">
        <div style="float:right;text-align: right;" class="col-8">
          <div class="row align-items-center">
            <span style="display: inline-block; vertical-align: middle;padding:5px">Follow Us On:</span>
            <a href="https://www.facebook.com/amcredit" target="_blank">
              <img
                style="display: inline-block; vertical-align: middle;"
                src="../../assets/imgs/smallIcon1.png"
                alt="facebook"
              />
            </a>
            <a href="https://www.twitter.com" target="_blank">
              <img
                style="display: inline-block; vertical-align: middle;"
                src="../../assets/imgs/smallIcon2.png"
                alt="twitter"
              />
            </a>
            <a href="https://americancredit.business.site/" target="_blank">
              <img
                style="display: inline-block; vertical-align: middle;"
                src="../../assets/imgs/smallIcon3.png"
                alt="business site"
              />
            </a>
            <a href="https://www.linkedin.com/company/amcredit" target="_blank">
              <img
                style="display: inline-block; vertical-align: middle;"
                src="../../assets/imgs/smallIcon4.png"
                alt="linkedin"
              />
            </a>
          </div>
        </div>
      </div>
      <div class="col-lg-8 col-sm-12">
        <div class="step-form__main pt-3">
          <br />
          <h3>Choose the Product You Want To Apply For</h3>
          <hr />
          <div class="row px-3">
            <div class="col-lg-3 col-sm-12"></div>

            <p />
            <el-form
              class="step-form__form"
              :label-width="'100%'"
              :model="ctlForm"
              :rules="rules"
              ref="ctlForm"
            >
              <el-row :gutter="0">
                <el-col :span="16">
                  <el-form-item label="Which Loan Would you like to Apply For?" prop="product">
                    <el-select v-model="ctlForm.product" v-on:change="onProductChange" placeholder class="select_width">
                      <el-option
                        v-for="item in productS"
                        :key="item.value"
                        :label="item.text"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="0">
                <el-col :span="16">
                  <el-form-item label="What is the amount you would like? ($20,000 - $5,000,000)" prop="amount">
                    <el-input type="number" onkeypress="return event.keyCode>=48&&event.keyCode<=57" v-model="ctlForm.amount">
                      <template slot="prepend">$</template>
                    </el-input>
                  </el-form-item>
                  <!-- <el-form-item label="What is the amount you would like? (Up to $5,000,000)" prop="amount">
                    <el-select v-model="ctlForm.amount" placeholder class="select_width">
                      <el-option
                        v-for="item in amountS"
                        :key="item.value"
                        :label="item.text"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </el-form-item> -->
                </el-col>
              </el-row>
              <el-row v-if="ctlForm.product === '10000057823975'">
                <el-col :span="16">
                  <el-form-item label="Desired loan term" prop="term">
                    <el-select v-model="ctlForm.term" placeholder class="select_width">
                      <el-option
                        v-for="item in equipmentLoanTermS"
                        :key="item.value"
                        :label="item.text.concat(' months')"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row v-if="ctlForm.product === '10000057880003'">
                <el-col :span="16">
                  <el-form-item label="Desired loan term" prop="term">
                    <el-select v-model="ctlForm.term" placeholder class="select_width">
                      <el-option
                        v-for="item in invoiceFinancingTermS"
                        :key="item.value"
                        :label="item.text.concat(' days')"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>

            <div style="font-family: lato;">
              <h4>CONSENTS</h4>By clicking the SUBMIT button below and continuing with the
              application process, you understand and agree that you are
              providing written instructionsto American Credit, Inc.
              under the Fair Credit Reporting Act authorizing American Credit,
              Inc., a California Licensed Lender, to obtain information from
              your business and personal credit profile or other information
              from one or more consumer reporting agencies, such as Experian,
              TransUnion, and Equifax. You authorize American Credit, Inc to
              obtain such information solely to conduct a credit-worthiness
              evaluation for credit options on any loan products offered by
              American Credit, Inc
            </div>

            <div class="step-form__btn-container">
              <!--<button class="step-form__btn-prev" @click="goBack">Back step</button>-->
              <!--<button class="step-form__btn-next" @click="submitForm">Next step</button>-->

              <el-button
                type="primary"
                class="rounded-pill bluebg px-5"
                style="float: left; "
                @click="goBack"
              >Prev</el-button>

              <el-button
                type="primary"
                :loading="isLoading"
                class="rounded-pill bluebg px-5"
                style="float: right;"
                @click="submitForm"
              >Submit</el-button>
            </div>
          </div>
          <br />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import _ from "lodash";
import placeholders from "../../scripts/placeholders";
import api from "../../vuex/api";
import Cookie from "js-cookie";
import { mapGetters, mapActions, mapMutations } from "vuex";
import * as types from "../../vuex/types";

// ä¼�ä¸šé‚£è¾¹å¦‚æžœç•Œé�¢å·®å¼‚å�˜å¤§ï¼Œåˆ™å»ºè®®åˆ†å‡ºåŽ»å�¦ä¸€ä¸ªç»„ä»¶
export default {
  data() {
    const assignValidator = (type, trigger = "blur") =>
      Object.assign(
        {
          //        required: true,
          trigger
        },
        {
          validator: (rules, value, callback, source, options) => {
            this.$store.dispatch(type, {
              rules,
              value,
              callback,
              source,
              options
            });
          }
        }
      );
    return {
      pickerOptions1: {
        /*disabledDate(time) {
            return time.getTime() < Date.now() - 8.64e7;
          }*/
      },
      isLoading: false,
      isLoadingCode: false,
      isSubmitting: false,
      isEditable: "",
      screenHeight: document.body.clientHeight,
      isApplyFirst: true,
      countDown: "",
      isRegistering: false,
      publicKey: "",
      isAllowSendingVerifyCode: true,
      isLoadingCode: false,
      SMSVerificationCodeBtn: {
        disabled: true,
        text: "get email verification code"
      },
      isLoading: false,
      isCounting: false,
      rules: {
        product: [
          {
            require: true,
            trigger: "blur",
            validator: (rules, value, callback) => {
              console.log("product");
              if (_.trim(value) === "") {
                callback(new Error("Product can not be empty"));
              } else {
                callback();
              }
            }
          }
        ],
        amount: [
          {
            require: true,
            trigger: "blur",
            validator: (rules, value, callback) => {
              console.log("amount");
              if (_.trim(value) === "") {
                callback(new Error("Amount can not be empty"));
              } else if (value < 20000) {
                callback(new Error("Minimum loan amount is $20,000"));
              } else if (value > 5000000) {
                callback(new Error("Maximum loan amount is $5,000,000"));
              }else {
                callback();
              }
            }
          }
        ],
        term: [
          {
            require: true,
            trigger: "blur",
            validator: (rules, value, callback) => {
              console.log("term");
              if (_.trim(value) === "") {
                callback(new Error("Term can not be empty"));
              } else {
                callback();
              }
            }
          }
        ]
      },
      productS: [
        { value: "10000057823975", text: "Equipment Loan" },
        { value: "10000057880003", text: "Invoice Financing" }
      ],
      amountS: [
        { value: "20000", text: "$20,000" },
        { value: "30000", text: "$30,000" },
        { value: "40000", text: "$40,000" },
        { value: "50000", text: "$50,000" },
        { value: "60000", text: "$60,000" },
        { value: "70000", text: "$70,000" },
        { value: "80000", text: "$80,000" },
        { value: "90000", text: "$90,000" },
        { value: "100000", text: "$100,000" },
        { value: "150000", text: "$150,000" },
        { value: "200000", text: "$200,000" },
        { value: "250000", text: "$250,000" },
        { value: "300000", text: "$300,000" },
        { value: "350000", text: "$350,000" },
        { value: "400000", text: "$400,000" },
        { value: "450000", text: "$450,000" },
        { value: "500000", text: "$500,000" },
        { value: "550000", text: "$550,000" },
        { value: "600000", text: "$600,000" },
        { value: "650000", text: "$650,000" },
        { value: "700000", text: "$700,000" },
        { value: "750000", text: "$750,000" },
        { value: "800000", text: "$800,000" },
        { value: "850000", text: "$850,000" },
        { value: "900000", text: "$900,000" },
        { value: "950000", text: "$950,000" },
        { value: "1000000", text: "$1,000,000" },
        { value: "1500000", text: "$1,500,000" },
        { value: "2000000", text: "$2,000,000" },
        { value: "2500000", text: "$2,500,000" },
        { value: "3000000", text: "$3,000,000" },
        { value: "3500000", text: "$3,500,000" },
        { value: "4000000", text: "$4,000,000" },
        { value: "4500000", text: "$4,500,000" },
        { value: "5000000", text: "$5,000,000" }
      ],
      //       termS:[{value:'10000058380004',text:'3'},{value:'10000058380006',text:'6'},{value:'10000058380008',text:'9'},{value:'10000058380010',text:'12'}],
      equipmentLoanTermS: [
        { value: "1", text: "1" },
        { value: "2", text: "2" },
        { value: "3", text: "3" },
        { value: "4", text: "4" },
        { value: "5", text: "5" },
        { value: "6", text: "6" },
        { value: "7", text: "7" },
        { value: "8", text: "8" },
        { value: "9", text: "9" },
        { value: "10", text: "10" },
        { value: "11", text: "11" },
        { value: "12", text: "12" },
        { value: "18", text: "18" },
        { value: "24", text: "24" },
        { value: "30", text: "30" },
        { value: "36", text: "36" },
        { value: "42", text: "42" },
        { value: "48", text: "48" },
        { value: "54", text: "54" },
        { value: "60", text: "60" },
        { value: "66", text: "66" },
        { value: "72", text: "72" }
      ],
      invoiceFinancingTermS: [
        { value: "15", text: "15" },
        { value: "30", text: "30" },
        { value: "45", text: "45" },
        { value: "60", text: "60" },
        { value: "75", text: "75" },
        { value: "90", text: "90" },
        { value: "105", text: "105" },
        { value: "120", text: "120" },
        { value: "135", text: "135" },
        { value: "150", text: "150" },
        { value: "165", text: "165" },
        { value: "180", text: "180" }
      ],
      mastateS: [],
      isEditable: 0,
      ctlForm: {
        product: "",
        amount: "",
        term: ""
      }
    };
  },
  computed: {
    ...mapGetters({
      myInfo: types.GET_MY_INFO,
      userInfo: types.GET_USER
    })
  },
  methods: {
    ...mapActions({
      ajaxBaseUrl: types.GET_AJAX_BASE_URL,
      updatePassword: types.UPDATE_PASSWORD,
      getPersonalInfo: types.GET_PERSONAL_INFO,
      getEnterpriseInfo: types.GET_ENTERPRISE_INFO,
      savePersonalInfo: types.SAVE_PERSONAL_INFO,
      saveEnterpriseInfo: types.SAVE_ENTERPRISE_INFO,
      saveApplyLoanProgress: types.SAVE_APPLY_LOAN_PROGRESS,
      setSuccessMessage: types.SET_SUCCESS_MESSAGE,
      setAlertMessage: types.SET_FAIL_MESSAGE,
      getPersonalInitData: types.GET_PERSONAL_INIT_DATA
    }),

    allowSendingVerifyCode(val) {
      if (this.isCounting === false) {
        this.isAllowSendingVerifyCode = val.trim() !== "";
        this.SMSVerificationCodeBtn = {
          disabled: val.trim() === "",
          text: "get email verification code"
        };
      }
    },

    getMgxyGetPersonDetails() {
      //èŽ·å�–è¿›ä»¶ä¸ªäººä¿¡æ�¯
    },

    formatData(data) {
      var arr = [];
      for (var key in data) {
        var obj = {};
        obj.value = data[key];
        obj.text = key;
        arr.push(obj);
      }
      return arr;
    },
    formatDataForSort(data) {
      var arr = [];
      var arr2 = [];
      for (var key in data) {
        arr[arr.length] = data[key];
      }
      arr.sort();
      for (var k in arr) {
        for (key in data) {
          if (data[key] == arr[k]) {
            var obj = {};
            obj.value = data[key];
            obj.text = key;
            arr2.push(obj);
          }
        }
      }
      return arr2;
    },

    inputBlurFn(prop) {
      if (event.srcElement) {
        this.ctlForm[prop] = event.srcElement.value;
      }
    },

    getMgxyDictionary() {
      var _this = this;
      api.mgxyDictionary().then(res => {
        _this.stateS = _this.formatData(res.data.result[0]);
        _this.titleData = _this.formatData(res.data.result[7]);
        _this.mastateS = _this.formatData(res.data.result[6]);
      });
    },

    goBack() {
      this.saveApplyLoanProgress({
        router: this.$router,
        token: this.userInfo.token,
        id: this.$route.query.applyLoanId,
        step: 1
      }).then(res => {
        const resData = res.data;
        if (Number(resData.code) === 0) {
          //            if (`${this.$route.query.isEdit}` === 'true') {
          this.$router.push({
            path: `/personalCenter/myLoan/loanLists`,
            query: {
              applyLoanId: this.$route.query.applyLoanId,
              isEdit: true
            }
          });
          //            } else {
          //              this.$router.go(-1)
          //            }
        }
      });
    },

    onProductChange() {
      console.log('reset loan');
      this.ctlForm.amount = "";
      this.ctlForm.term = "";
    },

    submitForm() {
      
      if (this.userInfo.token) {
        var _this = this;
        this.getPersonalInitData({
          token: this.userInfo.token,
          customerId: this.userInfo.crmCustomerId
        })
        .then(res => {
          console.log(res);
          if (Number(res.data.code) === 0) {
            const data = res.data.result;
            if(data.employer.industry == null || data.employer.dateEstablished == null || data.employer.revenue == null || data.employer.structure == null) {
              this.$alert('You need to complete business information first.', {
                callback: action => {
                  this.$router.push(`/applyLoan/${this.$route.params.id}/sbl01`);
                }
              });
            } else {
              this.$refs.ctlForm.validate(valid => {
              if (valid) {
                var frontApplyProductId, frontApplyExpiresUnit;
                if(this.ctlForm.product === '10000057823975') {
                  frontApplyProductId = 10000057823975;
                  frontApplyExpiresUnit = 2;
                }
                if(this.ctlForm.product === '10000057880003') {
                  frontApplyProductId = 10000057880003;
                  frontApplyExpiresUnit = 3;
                }

                api
                  .mgxyApply({
                    frontApplyProductId: frontApplyProductId,
                    tokenId: this.userInfo.token,
                    frontApplyMoney: this.ctlForm.amount,
                    frontApplyExpires: this.ctlForm.term,
                    frontApplyExpiresUnit: frontApplyExpiresUnit,
                    frontInformationSources: '5'
                  })
                  .then(res => {
                    console.log(res);
                    var data = res.data;
                    this.isLoading = false;
                    if (data.code == 0) {
                      localStorage.setItem("$applyId", data.result.frontApplyId); // ä¿�å­˜ ç”³è¯·å€Ÿæ¬¾id
                      this.complete();
                    } else {
                      this.$alert(res.data.msg);
                    }
                  });
              }
            });
            }
          } else {
            console.log(res.data);
          }
        })
        .catch(function(err) {
          // Instead, this happens:
          console.log("It failed!", err);
        });
      }
    },

    complete() {
      api
        .postForm(
          "/mobile/item/loanItemFrontApply/mgxyUpdateApplyForFinish.ht",
          {
            tokenId: this.userInfo.token,
            frontApplyId: localStorage.getItem("$applyId")
          }
        )
        .then(res => {
          this.isLoading = false;
          this.$router.push({
            path: `/personalCenter/myLoan/loanLists`,
            query: {
              applyLoanId: this.$route.query.applyLoanId, // applyLoanIdå…¶å®žæ”¾åœ¨storeæ›´å¥½å�§ï¼Ÿ
              isEdit: this.$route.query.isEdit
            }
          });
        });
    }

    //end of methods
  },

  mounted() {
    this.getMgxyDictionary();
  }
};
</script>

<style lang="scss">
.el-input.is-disabled .el-input__inner {
  background: #f7f7f7;
}

.step1-form .step-form__title {
  padding-bottom: 120px;
}

.step-text-active {
  font-weight: 700;
  color: #009dd9;
  border-bottom: 2px solid #009dd9;
}

.step-text {
  font-weight: 700;
  color: #009dd9;
  text-align: center;
  width: 300px;
}
</style>


// WEBPACK FOOTER //
// sbl.vue?13730ac6